<template>
	<div class="col-md-12 search result">
        <BootstrapTable
            ref="table"
            class="table table-borderless table-hover table-striped no-border table-bs"
            :columns="columns"
            :data="rows"
            :options="table.config"
			@on-click-row="onselectrow"
        />

		<div class="toolbox" v-if="rows.length && !noxls">
			<vue-excel-xlsx class="btn icon btn-light btn-secondary justify-content-center"
				:data="dataXLSX"
				:columns="columnXLSX"
				:file-name="reportname"
				:sheet-name="'Data'"
				>
				<i class="far fa-file-excel"></i>
			</vue-excel-xlsx>
		</div>

		<Loader v-if="loading" />

	</div>
</template>

<script>

import tableMixin from '../../mixins/table'
import '../../plugins/table.js'
import { AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

import Vue from 'vue'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

//Bootstrap-table ref:
//https://bootstrap-table.com/versions/1.15.5/docs/vuejs/introduction/
//https://bootstrap-table.com/docs/api/column-options/#footerformatter
//https://github.com/wenzhixin/bootstrap-table-examples/tree/develop/vue-starter
//https://examples.bootstrap-table.com/#column-options/natural-sorting.html

export default
{
    mixins: [tableMixin],
	components: {
		Loader,
        //BootstrapTable,
	},
	props:['reporturl', 'reportdata', 'reportname', 'rowtemplates', 'nopage', 'card_title', 'noxls', 'select_url', 'idcol', 'loading'],
	data() {
		return {
			table:
			{
				config: {
					//height:500,
                    pagination: !(this.nopage),
                    pageList: [10, 20, 50, 100, 'all'],
                    search: false,
                    showColumns: false,
                    showExport: false,

                    detailView: false, //card_mode
					rows_selectable: true,

					showFooter: false,
					//sidePagination: 'client',
					//footerField: this.rows,

					/*
					url: this.reporturl,
					responseHandler: function (res) {
						console.log('res: '+res)
						return res.data
					},
					*/
                    /*

					pagination_info: true,
					per_page: 10,
					per_page_options: [10, 20, 50, 100],
					highlight_row_hover: true,
					card_mode: false,
					card_title: false,

                    */

					//fixedColumns: true,
					//fixedNumber: 2,
				},
				classes: {
					table: "table-striped"
				},
			},
			reportdata_:[],
		}
	},
	watch:{
		reporturl(now) {
			AxiosWithJar().get(now).then((response)=>{
				this.reportdata_ = response.data;
			})
		}
	},
	computed:{
		_reportdata() {
			return this.reportdata ? this.reportdata : this.reportdata_;
		},
		columns() {
			let cols=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					if (columns[i].format != 'hidden') {
						cols.push({
							title: columns[i].title,
							field: columns[i].field,
							sortable: true,
							align: columns[i].format == 'number' || columns[i].format == 'percent' || columns[i].format == 'decimal' ? "right" : "left",
							valign: "middle",
							sorter: columns[i].format == 'number' || columns[i].format == 'percent' || columns[i].format == 'decimal' ? this.numericOnly : this.alphanum, //'numericOnly',
                            formatter: this.cellFormatter,
							//checkbox: true,
                            //rowspan: 2,
                            //colspan: 3,
							//row_classes:"", //unused
							//column_classes:"", //unused
						});
					}
				}
			}
			//console.log('cols: '+JSON.stringify(cols));
			return cols;
		},
		rows(){
			let rows=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				let data = this._reportdata['data'];
				for	(var j=0; j<data.length; j++) {
					let row={}
					for (var i=0; i<columns.length; i++){
						let a = data[j][columns[i].field]
						if (columns[i].format == 'number') a = this.formatNum(a * 1);
						if (columns[i].format == 'percent') a = this.formatNum(a * 100) + "%"; //a = this.formatNum(a * 100) + "%";
						row[columns[i].field] = a
						//console.log('log: ' + a);
					}
					rows.push(row)
				}
			}
			return rows;
		},
		columnXLSX()
		{
			let labels=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					let dt = {}
					dt['field'] = columns[i].field;
					dt['label'] = columns[i].title;
					labels.push(dt);
				}
			}
			return labels;
		},
		dataXLSX(){
			let rows=[];
			if (this._reportdata['columns']) {
				rows = this._reportdata['data'];
			}
			return rows;
		},

	},
	mounted(){
		if (this.card_title) {
			this.table.config.card_mode = true;
			this.table.config.card_title = this.card_title;
		}
	},
	methods:{
		cellFormatter(value, row) {
			//var icon = row.id % 2 === 0 ? 'fa-star' : 'fa-star-and-crescent'
			let val = value

			if(value == null)
				val = '-'

			if(value == 'CRITICAL' || value == 'BELUM OPERASIONAL')
				val = '<span class="el-tag el-tag--small el-tag--danger el-tag--dark" style="margin-left:10px;">' + value + '</span>'
			else if(value == 'ONLINE')
				val = '<span class="el-tag el-tag--small el-tag--dark" style="margin-left:10px;">' + value + '</span>'
			else if(value == 'NORMAL')
				val = '<span class="el-tag el-tag--small el-tag--success el-tag--dark" style="margin-left:10px;">' + value + '</span>'
			else if(value == 'LOW' || value == 'NOT UPDATE' || value == 'OFFLINE')
				val = '<span class="el-tag el-tag--small el-tag--warning el-tag--dark" style="margin-left:10px;">' + value + '</span>'

			return val
		},
		onselectrow(a) {
			if (this.idcol) {
				if(this.select_url) window.open(this.select_url + a[this.idcol],'_blank')
			}
		},
		/*
        numericOnly(a, b) {
            function stripNonNumber(s) {
				let decimalNumber = parseFloat(s.replace(/[^\d.]/g, ''));
				let decimalNumberForceTwoComma = decimalNumber.toFixed(2); //.numberFormat(2);
				//console.log('decimalNumber: '+ decimalNumber + '->decimalNumberForceTwoComma: ' +decimalNumberForceTwoComma);
				s = decimalNumberForceTwoComma.replace(new RegExp(/[^0-9]/g), '');

				//original source
                //s = s.replace(new RegExp(/[^0-9]/g), '');
                return parseInt(s, 10);
            }

            return stripNonNumber(a) - stripNonNumber(b);
        },
		*/
		numericOnly(a, b) {
			// Mengubah string ke angka untuk mempertahankan tanda positif/negatif
			const numA = parseFloat(a.replace(/,/g, ''));
			const numB = parseFloat(b.replace(/,/g, ''));

			// compare number
			return numA - numB;

			/*
			const result = numA - numB;
			// number format
			return result.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			*/
		},

		//alphanum
		alphanum(a1, b1) {
			let a = a1
			let b = b1
			if(a1 == null)
				a = 'z'
			if(b1 == null)
				b = 'z'

			console.log('a: ' + a)
			console.log('b: ' + b)
			function chunkify(t) {
				var tz = [];
				var y = -1;
				var n = 0;

				for (var i = 0; i <= t.length; i++) {
				var _char = t.charAt(i);

				var charCode = _char.charCodeAt(0);

				var m = charCode === 46 || charCode >= 48 && charCode <= 57;

				if (m !== n) {
					tz[++y] = '';
					n = m;
				}

				tz[y] += _char;
				}

				return tz;
			}

			function stringfy(v) {
				if (typeof v === 'number') {
				v = "".concat(v);
				}

				if (!v) {
				v = '';
				}

				return v;
			}

			var aa = chunkify(stringfy(a));
			var bb = chunkify(stringfy(b));

			for (var x = 0; aa[x] && bb[x]; x++) {
				if (aa[x] !== bb[x]) {
				var c = Number(aa[x]);
				var d = Number(bb[x]);

				if (c === aa[x] && d === bb[x]) {
					return c - d;
				}

				return aa[x] > bb[x] ? 1 : -1;
				}
			}

			return aa.length - bb.length;
		},
		//end alphanum
	}
}
</script>
<style>

.table {
	--bs-table-striped-bg: /*rgba(0, 0, 0, 0.0)*/ #FAFAFA !important; /**Remove if back to original color */
	--bs-table-hover-bg: rgba(0, 0, 0, 0.010)!important; /**Remove if back to original color */
}

.table-bs td{
	border-bottom: 1px solid #EBEEF5 !important;
	transition: background-color .25s ease;
	padding: 0.55rem 0.5rem !important;
	color: #606266 !important;
}

table.table{ font-size: 14px;}
table.table tr.vbt-table-tools{display: none;}
table.table th{ padding: 2px 10px !important;}
table.table .form-group{ margin-bottom: 0px;}


.search.result{ margin-top:6px; background:rgba(20,109,182,.0275); border-radius:5px 5px ; color:#666; padding:0px;   }
.search.result .toolbox {
    z-index: 99;
    position: fixed;
    bottom: 25px;
    right: 25px;
    display: flex; background: rgba(255,255,255,.75);
    border-radius: 25px;
}

.search.result .toolbox button {
	display: flex;
    font-size: 12px;
    align-items: center; background: rgba(20,109,182,.75) !important; color:#fff;
    border-radius: 15px;
}

.search.result .toolbox .btn.icon{ padding:15px; margin: 10px;}

.no-border {
    border: 0px solid #fff !important;
}

/** TABLE PAGINATION */

.fixed-table-body {
	background: white !important;
}



.fixed-table-pagination {
	padding-left:0px !important; /**20px */
	padding-right:0px !important; /**20px */
	padding-top:5px;
	padding-bottom:5px;
	background: white !important;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff !important;
  background-color: #409EFF /*#0d6efd*/ /*#c7251c*/ !important;
  border-color: #409EFF /*#dee2e6*/ !important;
}

.page-link {
	line-height: 1.3 !important;
	padding: 0.375rem 0.85rem !important;
	font-size:14px;
	color: #606266 /*#409EFF*/ /*#0d6efd*/ !important;
	margin-left: 10px;
	margin-right: 10px;
	border-radius: 2px;
	font-weight:bold;
	background-color: #f4f4f5 !important;
}

.btn.btn-secondary.dropdown-toggle {
	line-height: 1.3 !important;
	padding: 0.475rem 0.75rem !important;
	color: #fff !important;
	background-color: #409EFF /*#0d6efd*/ !important;
}

.page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: 0.1rem !important;
    border-bottom-left-radius: 0.1rem !important;
	border-top-right-radius: 0.1rem !important;
    border-bottom-right-radius: 0.1rem !important;
	padding-top: 5px !important;
    padding-bottom: 7px !important;
	padding-left: 15px !important;
    padding-right: 15px !important;
}

.page-item:last-child .page-link {
    border-top-right-radius: 0.1rem !important;
    border-bottom-right-radius: 0.1rem !important;
	border-top-right-radius: 0.1rem !important;
    border-bottom-right-radius: 0.1rem !important;
	padding-top: 5px !important;
    padding-bottom: 7px !important;
	padding-left: 15px !important;
    padding-right: 15px !important;
}

/** END TABLE PAGINATION */

</style>
